export const GOOGLE_PLAY_APP_URL = "https://play.google.com/store/apps/details?id=uk.co.classprofessional.parafolio";
export const APPLE_APP_URL = "https://apps.apple.com/us/app/parafolio/id6449023723";